var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowBackIos = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  "aria-hidden": "true",
  viewBox: "0 0 72 72"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
  id: "a",
  width: 31,
  height: 52,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAA0CAMAAABFGxP+AAAAAXNSR0IB2cksfwAAADxQTFRFAAAAECAgGR0gGCAgHCAiGx8jGx8jGh4iGiAiGR4iGSAgHB4kGh8jHR0jGh4jICAgGyAkGx4iHCAkHSAjImqmJgAAABR0Uk5TABBQIG/v/39/cFCA31CwEHCPgFCF9++uAAAA7ElEQVR4nJXV6wrCMAyG4YSpDIY4vP9rVBGdDDZrd2yafCnonzGeF9ZOG5mcDzPxGC8OH6IT957X3/lSfbCvTGGAvvH0mCJDF0yjdcnHt/Gczf4Ua9es3HDuljMHLB2xcMjJMe/u8OYer+7y4j7PXuDJSxy9yMRVlW5OL83E5z7d1M///dKlryAMwTi1Xbpr7tbpKlbFvfViMD+8ECyL84N18W6wbc4L9s07QXo5OBC/bxjI84GC7HyBID+fNlDn2wR6PujAzBcV2PkkAzg/RYDnpwjg/BQB9hSA+SkDMD9FEJqH+/9BVUu3eBp+V1pmZRSdERsAAAAASUVORK5CYII="
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  x: 19,
  y: 10,
  href: "#a"
})));
export default SvgArrowBackIos;